import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React from 'react';
import { useDisponibilidadISP } from '../../../../hooks/useDisponibilidadIsp';
import { BarChart } from '../../../../components/Charts/BarChart';
import { useDynamicViewState } from '../../context/dynamic-view-context';
import { addDays, format } from 'date-fns';
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import { useTranslation } from 'react-i18next';

const PARAMS = ({ objetivoId, periodo }) => {
  let fechaInicio = format(new Date(), 'yyyy-MM-dd');
  let fechaTermino = format(new Date(), 'yyyy-MM-dd');
  if (periodo.period === 'c') {
    fechaInicio = format(
      addDays(new Date(periodo.statePeriod.startDate), 1),
      'yyyy-MM-dd'
    );
    fechaTermino = format(
      addDays(new Date(periodo.statePeriod.endDate), 1),
      'yyyy-MM-dd'
    );
  }
  return {
    objetivoId,
    fechaInicio: fechaInicio ?? format(new Date(), 'yyyy-MM-dd'),
    fechaTermino: fechaTermino ?? format(new Date(), 'yyyy-MM-dd'),
    time: periodo.period,
    horarioId: 0,
  };
};

export function AvailabilityIsp({ objetivoId }) {
  const { filterPeriod, refreshTime } = useDynamicViewState();
  const params = PARAMS({ objetivoId, periodo: filterPeriod });
  const { t } = useTranslation();

  const { data, isLoading, isFetching, isError } = useDisponibilidadISP({
    ...params,
    refreshTime,
  });
  const processedData = React.useMemo(() => {
    let chartSerieUp = [];
    let chartSerieDown = [];
    let chartSerieNoMon = [];
    let chartCategory = [];

    if (!data || !data.length) {
      return {
        chartSerieUp: [],
        chartSerieDown: [],
        chartSerieNoMon: [],
        chartCategory: [],
      };
    }

    for (const item of data) {
      chartCategory.push(item.nodo_nombre);
      chartSerieUp.push(
        parseFloat(
          (
            item.porcentaje_uptime +
            item.porcentaje_eventos_cliente +
            item.porcentaje_marcados_atentus
          ).toFixed(2)
        )
      );
      chartSerieDown.push(parseFloat(item.porcentaje_downtime.toFixed(2)));
      chartSerieNoMon.push(
        parseFloat(item.porcentaje_no_monitoreos.toFixed(2))
      );
    }
    return {
      chartSerieUp,
      chartSerieDown,
      chartSerieNoMon,
      chartCategory,
    };
  }, [data]);

  if (!isLoading && !data && !isError) {
    return (
      <Alert severity="error">
        No se encontraron datos de disponibilidad para el objetivo seleccionado.
      </Alert>
    );
  }

  if (!isLoading && isError) {
    return (
      <Alert severity="error">
        Ocurrió un error al obtener los datos de disponibilidad de los nodos.
      </Alert>
    );
  }

  if (isLoading || isFetching) {
    return <AtCircularProgress />;
  }

  const {
    chartSerieUp,
    chartSerieDown,
    chartSerieNoMon,
    chartCategory,
  } = processedData;

  return (
    <Box>
      <BarChart
        chartCategory={chartCategory}
        chartSerieUp={chartSerieUp}
        chartSerieDown={chartSerieDown}
        chartSerieNoMon={chartSerieNoMon}
        title={t("availability-isp.chart.title")}
        isLoading={isLoading}
      />
    </Box>
  );
}
